package br.com.texeratx.boardgametimeapp.core.network

import io.ktor.client.engine.*
import io.ktor.client.engine.js.*

actual fun httpClientEngine(): HttpClientEngine = Js.create()
